'use client';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { MinusCircle, PlusCircle, Tick } from '../../../../../public/Images';
import Typography from '@/components/shared/typography/typography.component';
import colors from '@/theme/colors.module.scss';
import styles from './styles.module.scss';
import { useTranslation } from '@/hook';
import { numberWithCommas } from '@/utils';

interface IWhatsIncludedItem {
  title: string;
  subtitle?: string | null;
  price?: number | null;
  content?: string[];
  expandedDefault?: boolean;
}

const WhatsIncluedItem = ({
  title,
  subtitle,
  price,
  content,
  expandedDefault = false,
}: IWhatsIncludedItem) => {
  const { t, i18n, IS_RTL } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(expandedDefault);
  useEffect(() => {
    setExpanded(expandedDefault);
  }, [expandedDefault]);
  return (
    <div className={`${styles.container}`}>
      <section className={styles.innerContainer}>
        <div className={`${styles.titleContainer}`}>
          <Image src={Tick} width={20} height={20} alt="check" />
          <Typography variant="captionSemiBold" color={colors.gray600}>
            {title}
          </Typography>
          {!!price && (
            <div className={styles.priceContainer}>
              <Typography variant="caption" color={colors.grayModern500}>
                {t('EGP')}
              </Typography>
              <Typography
                variant="body1SemiBold"
                className={IS_RTL ? 'strikethroughAr' : 'strikethrough'}
                color={colors.gray600}
              >
                {numberWithCommas(price)}
              </Typography>
            </div>
          )}
        </div>
        {subtitle && expanded && (
          <div className={styles.contentContainer}>
            <Typography variant="captionMedium" color={colors.gray600}>
              {subtitle}
            </Typography>
            <ul className={styles.list}>
              {content?.length &&
                content?.map((listItem, index) => (
                  <li key={`whatsIncluded_${index}`}>
                    <Typography variant="caption" color={colors.gray600}>
                      {listItem}
                    </Typography>
                  </li>
                ))}
            </ul>
          </div>
        )}
      </section>
      {(content || subtitle) && (
        <button className={styles.btnContainer} onClick={() => setExpanded((prev) => !prev)}>
          <Image src={expanded ? MinusCircle : PlusCircle} alt="expand" width={20} height={20} />
        </button>
      )}
    </div>
  );
};

export default WhatsIncluedItem;
